<ng-container *ngrxLet="serviceTicketStore.activePage$ as activePage">
  <div class="header">
    <ng-container *ngIf="activePage === ServiceTicketPage.Create">
      <mat-icon
        class="header__icon"
        (click)="closeOverlay()"
        gtm="onClose"
        gtmAction="Assistant side panel closed"
        gtmCategory="Service Ticket"
      >
        close
      </mat-icon>
      <a
        class="header__label"
        routerLinkActive="hide"
        [routerLink]="['/assistant']"
        gtm="onClose"
        gtmAction="Assistant side panel closed"
        gtmCategory="Service Ticket"
        (click)="closeOverlay()"
      >
        {{ '+SERVICE_TOOL.NAVIGATION_ASSISTANT' | translate }}
        <mat-icon>arrow_forward</mat-icon>
      </a>
    </ng-container>

    <ng-container
      *ngIf="activePage === ServiceTicketPage.Call || activePage === ServiceTicketPage.Articles"
    >
      <span class="header__label" (click)="navigateBackToCreatePage()">
        <mat-icon class="header__icon">arrow_back</mat-icon>
        {{ 'GENERAL.BUTTON.BACK' | translate }}
      </span>
      <a
        class="header__label"
        routerLinkActive="hide"
        [routerLink]="['/assistant']"
        (click)="closeOverlay()"
      >
        {{ '+SERVICE_TOOL.NAVIGATION_ASSISTANT' | translate }}
        <mat-icon>arrow_forward</mat-icon>
      </a>
    </ng-container>
  </div>

  <div class="content">
    <app-service-ticket-page-create
      [class.content-visible]="activePage === ServiceTicketPage.Create"
    ></app-service-ticket-page-create>
    <app-service-ticket-page-call
      [class.content-visible]="activePage === ServiceTicketPage.Call"
    ></app-service-ticket-page-call>
    <app-service-ticket-page-articles
      [class.content-visible]="activePage === ServiceTicketPage.Articles"
    >
    </app-service-ticket-page-articles>
  </div>
</ng-container>
